import { Upload} from '../../components/upload'
import { Delete } from '../../components/delete'
export class Content {
    constructor() {
        this.endpoint = 'content'
        this.boot = [{ index : [
            () => {
                new Delete()

            }
        ],
     select : [

     ]}]
     this.uploadForm()
    }

    uploadForm() {
       const uploadForm = ui.select('#upload_form')
       if(uploadForm)
            new Upload(uploadForm)

    }
}
